import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import {
  SellerStatementGroup,
  SellerStatementItem,
} from '@/app/services/sellersService/sellerStatement'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import { StatusEnum } from '@/app/utils/status'
import { cn } from '@/app/utils/cn'

interface SellerStatementListProps {
  data: SellerStatementGroup[]
  onTransactionClick?: (transaction: SellerStatementItem) => void
}

const formatTime = (date: string) => format(new Date(date), 'HH:mm')

const getBalance = (transactions: SellerStatementItem[]) => {
  return transactions.reduce((acc, transaction) => {
    if (
      transaction.type === 'WITHDRAW' ||
      transaction.status === StatusEnum.REFUNDED
    ) {
      return acc - transaction.value
    }

    return acc + transaction.value
  }, 0)
}

const Item = ({ item }: { item: SellerStatementItem }) => {
  const isWithdraw = item.type === 'WITHDRAW'
  const isRefunded = item.status === StatusEnum.REFUNDED

  const label = isWithdraw
    ? 'Saque'
    : `${isRefunded ? 'Estorno ' : 'Proposta '}${item.contract} -`
  const amount = formatMoneyValue(
    item.value * (isWithdraw || isRefunded ? -1 : 1),
  )

  return (
    <div className={cn("flex items-center justify-between gap-2", !isWithdraw && 'cursor-pointer')}>
      <div className="flex gap-2">
        {item.statusAt && (
          <p className="font-semibold">{formatTime(item.statusAt)}</p>
        )}
        <p className="">{label}</p>
        {!isWithdraw && <p className=" ">{item.type}</p>}
      </div>

      <p
        className={cn(
          isRefunded || isWithdraw ? 'text-error' : 'text-success',
        )}
      >
        {amount}
      </p>
    </div>
  )
}

export const SellerStatementList = ({
  data,
  onTransactionClick,
}: SellerStatementListProps) => {
  return (
    <div className="space-y-2">
      {data.map((group) => {
        const balance = getBalance(group.transactions)
        const balanceIsPositive = balance > 0
        const balanceIsNegative = balance < 0
        return (
          <div key={group.date} className="py-2">
            <div className="flex items-baseline justify-between gap-4">
              <h3 className="mb-3 font-semibold text-black04">
                {'Resumo do dia '}
                {format(new Date(group.date), 'dd/MM/yyyy', {
                  locale: ptBR,
                })}
              </h3>
              <div className="h-1 flex-1 border-t border-dashed border-black04" />
              <p
                className={cn(
                  'font-semibold text-black03',
                  balanceIsPositive && 'text-success',
                  balanceIsNegative && 'text-error',
                )}
              >
                {balanceIsPositive && '+'}
                {formatMoneyValue(balance)}
              </p>
            </div>

            <div className="">
              {group.transactions.map((transaction, index) => (
                <div
                  key={`${group.date}-${transaction.contract}-${transaction.type}-${transaction.statusAt}-${index}`}
                  className="flex flex-col gap-1 rounded-lg  py-2 "
                  onClick={() => {
                    if (transaction.type === 'WITHDRAW') {
                      return
                    }

                    onTransactionClick?.(transaction)
                  }}
                >
                  <Item item={transaction} />
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
